export default __webpack_public_path__ + "static/media/下拉.86975f17.svg";